<!-- 搜索栏组件 -->
<template>
<div class="search-box">
  <div class="search-tool" @mouseover="hoverIpt=1" @mouseout="hoverIpt=0" :class="hoverIpt===1?'hover-ipt':''">
    <input type="text" class="search-ipt" v-model="value" :placeholder="placeholder" />
    <img :src="ishover?searchActive:search" class="search-btn" @click="clickSearch" @mouseover="ishover=true" @mouseout="ishover=false">
  </div>
</div>
</template>
<script type="text/ecmascript-6">
import {search, searchActive} from 'utils/imgUrl'
import {getSearchData} from 'utils/api/index'
export default {
  data () {
    return {
      search,
      hoverIpt: 0,
      searchActive,
      placeholder: '搜索要查找的报表名',
      ishover: false,
      value: ''
    }
  },
  methods: {
    clickSearch () {
      this.value && this.$emit('getSearchData', this.value)
    }
  },
  created () {
    window.addEventListener('keydown', (key) => {
      key.keyCode === 13 && this.clickSearch()
    }, false)
  },
  watch: {
    value () {
      this.$emit('getSearchData', this.value)
    }
  }
}
</script>
<style lang="less">
@import "~assets/style/mixin";
@import "~assets/style/variable";
.search-box {
  height: 100%;
  display: flex;
  align-items: center;
}
.search-tool {
  width: 190px;
  height: 30px;
  border-radius: 15px;
  background: #fff;
  display: flex;
  align-items: center;
  opacity: 0.85;
}
.hover-ipt {
  opacity: 1 !important;
}
.search-ipt {
  width: 135px;
  font-size: @font-size-medium;
  margin-left: 10px;
  height: 14px;
  color: #333;
  .cursor-pointer;
}
.search-btn {
  width: 30px;
  height: 30px;
  margin-left: 10px;
}

.search-ipt::-webkit-input-placeholder { /* WebKit browsers */
  color:#999;
}
.search-ipt:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color:#999;
}
.search-ipt::-moz-placeholder { /* Mozilla Firefox 19+ */
  color:#999;
}
.search-ipt:-ms-input-placeholder { /* Internet Explorer 10+ */
  color:#999;
}
</style>



// WEBPACK FOOTER //
// src/components/searchReport.vue